import { SimType, ValidateSimFreeResponse } from '../../generated/api/models.js';
import { dataNotAvailableMsg, invalidSIMCardNumberMsg, simCardAlreadyInUseMsg, simCardMsg, t } from '../i18n/index.js';
import { ELISA_ICCID_PREFIX, SIM_CARD_REGEX } from './validationUtils.js';

export enum SimOption {
  ORDER_NEW_PHYSICAL,
  ORDER_NEW_ESIM,
  ORDER_NEW_PHYSICAL_MINI_MICRO,
  ORDER_NEW_PHYSICAL_NANO,
  ACTIVATE_EXISTING_PHYSICAL,
}

export const ACTIVATE_EXISTING = 'ACTIVATE_EXISTING';

export const getSimTypeAsString = (simType?: SimType): string => {
  switch (simType) {
    case SimType.PHYSICAL_MINI_MICRO:
      return 'Mini + Micro';

    case SimType.PHYSICAL_NANO:
      return 'Nano';

    case SimType.PHYSICAL:
      return t.PIZC(simCardMsg);

    case SimType.ESIM:
      return 'eSIM';

    default:
      return t.PJC3(dataNotAvailableMsg);
  }
};

// Copied from https://github.com/EDumdum/luhn/blob/master/src/luhn.js (MIT license)
export function getLuhnRemainder(value: string) {
  value = ELISA_ICCID_PREFIX + value;
  const CHARCODE_0 = '0'.charCodeAt(0);
  const MAPPING_EVEN = [0, 2, 4, 6, 8, 1, 3, 5, 7, 9];
  let length = value.length;
  let accumulator = 0;
  let bit = 0;

  while (length-- > 0) {
    // eslint-disable-next-line
    accumulator += (bit ^= 1)
      ? value.charCodeAt(length) - CHARCODE_0
      : MAPPING_EVEN[value.charCodeAt(length) - CHARCODE_0];
  }

  return accumulator % 10;
}

export const localizeValidationErrorMessage = (errorType: string) => {
  switch (errorType) {
    case ValidateSimFreeResponse.ErrorTypeEnum.ALREADY_IN_USE: {
      return t.ZNS1(simCardAlreadyInUseMsg);
    }
    case ValidateSimFreeResponse.ErrorTypeEnum.INVALID_NUMBER: {
      return t.SDXB(invalidSIMCardNumberMsg);
    }
    default:
      // This should never happen but if it does, there is probably some another error somewhere
      return undefined;
  }
};

export const isInvalidSimCardNumber = (simCardNumber: string): boolean =>
  !simCardNumber.match(new RegExp(SIM_CARD_REGEX)) || getLuhnRemainder(simCardNumber) !== 0;
